import { Festival } from "@prisma/client";
import { useMatches } from "remix";

export function useFestival(): Festival | null {
  const matches = useMatches();

  const matchWithFestival = matches.find((match) => !!match.data?.festival);

  return matchWithFestival ? matchWithFestival.data.festival : null;
}
